import { IsBoolean, IsInt, IsOptional } from 'class-validator';
import { Exclude } from 'class-transformer';
import { BaseDto } from '../base.dto';

/**
 * DTO object for patching of Brand Member.
 */
export class BrandMemberUpdateDto extends BaseDto {
  @Exclude()
  brandId: number;

  @Exclude()
  customerId: number;

  @IsOptional()
  @IsInt()
  membershipTypeId: number;

  @Exclude()
  code: string;

  @IsOptional()
  @IsBoolean()
  active: boolean;

  @IsOptional()
  appleWalletS3Link: string;

  @IsOptional()
  googleWalletJwtLink: string;
}
